jQuery(function ($) {
    $(document).ready(function () {
        if ($(".scientific-data-accordion").length > 0) {
            $('.scientific-data-accordion .tab-container').click(function (e) {
                e.preventDefault();

                if (window.innerWidth >= 1280) {
                    return;
                }

                let $this = $(this);

                $('.scientific-data-accordion .active').each(function () {
                    if (! $(this).is($this)) {
                        $(this).children().last().slideUp(200);
                        $(this).children().last().addClass('hidden');
                        $(this).find('.icon-arrow-down').removeClass('rotate-180');
                        $(this).removeClass('active');
                    }
                });

                $this.children().last().slideToggle(200);
                $this.children().last().toggleClass('hidden');
                $this.find('.icon-arrow-down').toggleClass('rotate-180');
                $this.toggleClass('active');
            });
        }
    });
});
